import React, { FC } from "react";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { TextField } from "@comparaonline/ui-form-fields-next";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import { FieldValidator } from "final-form";
import Typography from "@material-ui/core/Typography";
import { Form, FormProps } from "react-final-form";

import { CheckoutLayout } from "../../modules/common/components/CheckoutLayout";

const required: FieldValidator<unknown> = value =>
  value && String(value).length > 0 ? undefined : { errorCode: "required" };

interface GenericLoginValues {
  user: string;
  password: string;
}

export interface GenericLoginProps {
  onSubmit: FormProps<GenericLoginValues>["onSubmit"];
  warningMessage?: string;
}

export const GenericLogin: FC<GenericLoginProps> = ({ onSubmit, warningMessage }) => {
  return (
    <CheckoutLayout
      mainContent={
        <Form<GenericLoginValues> onSubmit={onSubmit}>
          {({ handleSubmit }) => (
            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <CardHeader title="Compara Login" />
              <CardContent>
                {warningMessage && <Typography color="error">{warningMessage}</Typography>}
                <div>
                  <TextField name="user" validate={required} />
                  <TextField
                    name="password"
                    validate={required}
                    muiInputProps={{ type: "password" }}
                  />
                </div>
              </CardContent>
              <CardActions>
                <Button type="submit" color="primary" fullWidth variant="extendedFab">
                  Login
                </Button>
              </CardActions>
            </form>
          )}
        </Form>
      }
    />
  );
};
